module.exports = "/images/vendor/desiigner-svg/svg/ui/chevron-down.svg?ef77e74d70c38044db8153d614a224e7";